import React from 'react';

import EmptyState from '@adsk/alloy-react-empty-state';

import { useTranslation } from '../i18n';

const FormTemplatesCustomPickerEmptyState = () => {
  const { t } = useTranslation();
  return (
    <EmptyState
      illustrationType={EmptyState.ILLUSTRATION_TYPES.FOLDER_EMPTY_GREY}
      title={t('NO_FORM_TEMPLATES_FOUND')}
    />
  );
};

export default FormTemplatesCustomPickerEmptyState;
